import { LENGTH_CLASS_DATA } from '../actions/actionType'

const initialState = {
  lengthClasses: [],
}
export default function LengthClassReducer(state = initialState, action) {
  switch (action.type) {
    case LENGTH_CLASS_DATA:
      return { ...state, lengthClasses: action.payload }
    default:
      return state
  }
}
